// Zitadel's hosted login, through the authorization code flow with PKCE.
//
// The same arrangement coachai has: oidc-client-ts does the protocol —
// discovery, the code challenge, the redirect, the token exchange, silent
// renewal — and this file adds the configuration and the one rule the app
// cares about. The access token is the credential the API sees, and it is
// handed to the transport rather than decoded here; the server re-resolves the
// caller on every request.
//
// The store is sessionStorage, which is the whole difference between a parent's
// credential and the device's pairing: see lib/session.tsx.

import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const issuer = import.meta.env.VITE_ZITADEL_ISSUER as string | undefined;
const clientID = import.meta.env.VITE_ZITADEL_CLIENT_ID as string | undefined;

export const CALLBACK_PATH = '/auth/callback';

/** Whether this build was given a Zitadel to talk to. */
export function oidcConfigured(): boolean {
  return !!issuer && !!clientID;
}

let manager: UserManager | null = null;

export function oidc(): UserManager {
  if (!manager) {
    if (!issuer || !clientID) {
      throw new Error(
        'VITE_ZITADEL_ISSUER und VITE_ZITADEL_CLIENT_ID sind für den Zitadel-Build nötig',
      );
    }
    manager = new UserManager({
      authority: issuer,
      client_id: clientID,
      redirect_uri: `${window.location.origin}${CALLBACK_PATH}`,
      post_logout_redirect_uri: window.location.origin,
      response_type: 'code',
      scope: 'openid profile email offline_access',
      automaticSilentRenew: true,
      userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    });
  }
  return manager;
}
